//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["logList", 'isEnd'],
  methods: {
    isCurrent(index) {
      return index == 1;
    }
  }
};



// WEBPACK FOOTER //
// ./src/pcComponents/mine/timeLine.vue